// extracted by mini-css-extract-plugin
export default {"box":"AvatarV1_box__Ot7HR","image":"AvatarV1_image__J6s9j","text":"AvatarV1_text__N4ebS"};